import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';

export interface IComunidadesAutonomasFieldProps {
    field: string;
    title: string;
    label: string;
    color?: string;
}

export interface IComunidadesAutonomasFieldState {
    data: any[];
    totalMen: number;
    totalWoman: number;
    sexData: any[];
}

export default class ComunidadesAutonomasField extends React.Component<IComunidadesAutonomasFieldProps, IComunidadesAutonomasFieldState> {
    public constructor(props: IComunidadesAutonomasFieldProps) {
        super(props);

        this.state = {
            data: [],
            totalMen: 0,
            totalWoman: 0,
            sexData: []
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IComunidadesAutonomasFieldProps>, nextContext: any): void {
        this.Get(nextProps.field);
        this.GetTotalFieldMenData(nextProps.field);
    }

    componentDidMount(): void {
        this.Get(this.props.field);
        this.GetTotalFieldMenData(this.props.field);
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            {
                                this.props.title
                            }
                        </Typography>
                        <Stack direction={'row'}>
                            <ManIcon style={{fontSize: '16px', color: Common.MAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                            {
                                this.GetTotalMen()
                            }
                            </Typography>
                            <WomanIcon style={{fontSize: '16px', color: Common.WOMAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                            {
                                this.GetTotalWomen()
                            }
                            </Typography>
                        </Stack>
                    </Box>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <PieChart
                                series={[
                                    {
                                        data: this.state.data,
                                        innerRadius: 45,
                                        outerRadius: 90,
                                        paddingAngle: 0,
                                        highlightScope: { faded: 'global', highlighted: 'item' },
                                        faded: { innerRadius: 45, additionalRadius: -30, color: 'gray' }
                                    }
                                ]}
                                margin={{
                                    left: 50,
                                    right: 50,
                                    bottom: 150,
                                    top: 50
                                }}
                                height={350}
                                slotProps={
                                    {
                                        legend: {
                                            direction: 'row',
                                            position: {
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            },
                                            itemMarkWidth: 20,
                                            itemMarkHeight: 6,
                                            markGap: 5,
                                            itemGap: 10,
                                            labelStyle: {
                                                fontSize: 11
                                            }
                                        }
                                    }
                                }
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <LineChart
                                dataset={this.state.sexData}
                                xAxis={[{ scaleType: 'point', dataKey: 'comunidadAutonoma' }]}
                                series={[
                                    { dataKey: 'hombres', label: 'Hombres', color: Common.MAN_BORDER_COLOR },
                                    { dataKey: 'mujeres', label: 'Mujeres', color: Common.WOMAN_BORDER_COLOR}
                                ]}
                                height={350}
                                margin={{
                                    bottom: 100
                                }}
                                slotProps={
                                    {
                                        legend: {
                                            direction: 'row',
                                            position: {
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            },
                                            itemMarkWidth: 20,
                                            itemMarkHeight: 6,
                                            markGap: 5,
                                            itemGap: 10,
                                            labelStyle: {
                                                fontSize: 11
                                            }
                                        }
                                    }
                                }
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }

    private Get(field: string) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/field/${field}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const length = response.length;
            const data: any[] = [];

            if(length > 0) {
                console.log(length);
                let startColor = '#ffe000';
                let endColor = '#ff9900';

                const palletteMap = Common.FIELD_PALETTE_MAP;

                const fieldColors = palletteMap.find((fieldColor: any) => {
                    return fieldColor.field.toLowerCase() == field.toLowerCase();
                });

                if(fieldColors != null) {
                    startColor = fieldColors.colors[0];
                    endColor = fieldColors.colors[1]
                }

                const gradientArray = new Gradient()
                .setColorGradient(startColor, endColor)
                .setMidpoint(length > 1 ? length : 2)
                .getColors();

                for(let i = 0; i < response.length; i++) {
                    const dataItem: any = {};
                    dataItem.id = i;
                    dataItem.label = response[i].comunidadAutonoma;
                    dataItem.value = response[i].total;
                    dataItem.color = gradientArray[i];

                    data.push(dataItem);
                }
            }

            this.setState(
                {
                    data: data
                }
            );
        })
    }

    private GetTotalFieldMenData(field: string) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/h/${field}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                dataItem.hombres = response[i].total;
                dataItem.mujeres = 0;

                data.push(dataItem);
            }

            this.GetTotalFieldWomenData(field, data);
        })
    }

    private GetTotalFieldWomenData(field: string, sourceData: any[]) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/m/${field}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = JSON.parse(JSON.stringify(sourceData));

            for(let i = 0; i < response.length; i++) {
                let dataItem: any = data.find((value: any) => {
                    return value.comunidadAutonoma == response[i].comunidadAutonoma;
                });

                if (dataItem == null) {
                    dataItem = {};
                    dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                    dataItem.hombres = 0;

                    data.push(dataItem);
                }

                dataItem.mujeres = response[i].total;
            }

            data.sort((a, b) => {
                if(a.comunidadAutonoma < b.comunidadAutonoma) { return -1; }
                if(a.comunidadAutonoma > b.comunidadAutonoma) { return 1; }
                return 0;
            });
            
            this.setState({
                sexData: data
            })
        })
    }

    private GetTotalMen() {
        const data = this.state.sexData.filter((value: any) => {
            return value.hombres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.hombres;
        }, 0);

        return sum;
    }

    private GetTotalWomen() {
        const data = this.state.sexData.filter((value: any) => {
            return value.mujeres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.mujeres;
        }, 0);

        return sum;
    }
}